import React from 'react';

import { flagStyles } from '../settings';

const SvgMH = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3384px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMH;
